import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Header from "@/components/site/Header";
import Intro from "@/components/site/Intro";
import FloatingCta from "@/components/site/FloatingCta";
import Hero from "@/components/site/Hero";
import CosaFaccio from "@/components/site/CosaFaccio";
import ChiSono from "@/components/site/ChiSono";
import Ledger from "@/components/site/Ledger";
import CompetitionMap from "@/components/site/CompetitionMap";
import Services from "@/components/site/Services";
import Tailored from "@/components/site/Tailored";
import Strutture from "@/components/site/Strutture";
import Blog from "@/components/site/Blog";
import Faq from "@/components/site/Faq";
import ClientPortal from "@/components/site/ClientPortal";
import Footer from "@/components/site/Footer";
import LeadModal from "@/components/site/LeadModal";
import CallReasonModal from "@/components/site/CallReasonModal";
import SopralluogoModal from "@/components/site/SopralluogoModal";
import PrivacyModal from "@/components/site/PrivacyModal";
import CookieNotice from "@/components/site/CookieNotice";
import FotografoPage from "@/pages/FotografoPage";
import CommercialistaPage from "@/pages/CommercialistaPage";
import AprireBbPage from "@/pages/AprireBbPage";
import RevenueManagerPage from "@/pages/RevenueManagerPage";
import GuidePage from "@/pages/GuidePage";

function HomePage() {
  useEffect(() => {
    const saved = sessionStorage.getItem("yu-home-scroll");
    if (!saved) return undefined;
    const y = parseInt(saved, 10);
    const start = Date.now();
    let timer;
    const tryJump = () => {
      if (window.__lenis) {
        window.__lenis.resize();
        window.__lenis.scrollTo(y, { immediate: true, force: true });
      }
      window.scrollTo(0, y);
      if (Math.abs(window.scrollY - y) > 200) {
        if (Date.now() - start < 7000) timer = setTimeout(tryJump, 350);
      } else {
        try {
          sessionStorage.removeItem("yu-home-scroll");
        } catch {}
      }
    };
    timer = setTimeout(tryJump, 150);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Intro />
      <Header />
      <main className="flex flex-col sm:block">
        <div className="order-1 sm:order-none"><Hero /></div>
        <div className="order-2 sm:order-none"><CosaFaccio /></div>
        <div className="hidden sm:block"><CompetitionMap /></div>
        <div className="order-3 sm:order-none"><Ledger /></div>
        <div className="order-6 sm:order-none"><Strutture /></div>
        <div className="order-7 sm:order-none"><ChiSono /></div>
        <div className="order-5 sm:order-none"><Services /></div>
        <div className="order-4 sm:order-none"><Tailored /></div>
        <div className="hidden sm:block"><Blog /></div>
        <div className="order-8 sm:order-none"><Faq /></div>
        <div className="order-9 sm:order-none"><ClientPortal /></div>
      </main>
      <Footer />
    </>
  );
}

function LenisManager() {
  const location = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const saveHomeScroll = (e) => {
      const anchor = e.target.closest("a[href^='/']");
      if (!anchor || window.location.pathname !== "/") return;
      const href = anchor.getAttribute("href");
      if (href === "/" || href.startsWith("/api")) return;
      try {
        sessionStorage.setItem("yu-home-scroll", String(Math.round(window.scrollY)));
      } catch {}
    };
    document.addEventListener("click", saveHomeScroll);
    return () => document.removeEventListener("click", saveHomeScroll);
  }, []);

  return (
    <BrowserRouter>
      <div className="App" id="top">
        <div className="grain" aria-hidden="true" />
        <LenisManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/fotografo-strutture-ricettive-sicilia" element={<FotografoPage />} />
          <Route path="/commercialista-affitti-brevi-sicilia" element={<CommercialistaPage />} />
          <Route path="/aprire-struttura-ricettiva-sicilia" element={<AprireBbPage />} />
          <Route path="/revenue-manager-case-vacanze-sicilia" element={<RevenueManagerPage />} />
          <Route path="/guide" element={<GuidePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <LeadModal />
        <CallReasonModal />
        <SopralluogoModal />
        <PrivacyModal />
        <CookieNotice />
        <FloatingCta />
        <Toaster theme="dark" position="bottom-center" />
      </div>
    </BrowserRouter>
  );
}

export default App;
